import type { Extensions } from "@tiptap/core";
import Blockquote from "@tiptap/extension-blockquote";
import Bold from "@tiptap/extension-bold";
import Code from "@tiptap/extension-code";
import CodeBlock from "@tiptap/extension-code-block";
import Color from "@tiptap/extension-color";
import Document from "@tiptap/extension-document";
import FontFamily from "@tiptap/extension-font-family";
import HardBreak from "@tiptap/extension-hard-break";
import Heading from "@tiptap/extension-heading";
import Highlight from "@tiptap/extension-highlight";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Italic from "@tiptap/extension-italic";
import Link from "@tiptap/extension-link";
import { BulletList, ListItem, OrderedList, TaskItem, TaskList } from "@tiptap/extension-list";
import Paragraph from "@tiptap/extension-paragraph";
import Strike from "@tiptap/extension-strike";
import Text from "@tiptap/extension-text";
import { TextStyle } from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import { Title } from "./title";

export const defaultTextExtensions = [
  Document,
  Title,
  Paragraph,
  Text,
  Bold,
  Italic,
  Underline,
  Strike,
  Heading,
  HardBreak,
  FontFamily,
  TextStyle,
  Color,
  Highlight.configure({ multicolor: true }),
  ListItem,
  BulletList,
  OrderedList,
  TaskList,
  TaskItem,
  Code,
  CodeBlock,
  Blockquote,
  Link,
  HorizontalRule,
] as const;

export const defaultExtensions: Extensions = defaultTextExtensions as unknown as Extensions;
